module.exports = __webpack_public_path__ + "img/icon03.c7c591fc.jpg";